
import { LOGIN_USER , LOGOUT_USER, AUTHENTICATION_LOADING } from '../actions/Types'

const init_state = {
    loginStatus: false,
    loading: true
    

}
const  Authentication= (state=init_state, action) => {
    switch(action.type){
        case LOGOUT_USER:
            return init_state
        case LOGIN_USER:
            return action.payload
        case  AUTHENTICATION_LOADING:
            return {...state, loading : action.payload}
        default:
            return state
    }
    
}
export default Authentication